export interface NotificationPermissionSnapshot {
  contextKey: string | null;
  permission: NotificationPermission | null;
}

export function resolveNotificationPermissionForContext(
  snapshot: NotificationPermissionSnapshot,
  contextKey: string,
) {
  if (snapshot.contextKey !== contextKey) {
    return { permission: null, resolved: false } as const;
  }
  return { permission: snapshot.permission, resolved: true } as const;
}
